var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVahakMember = function SvgVahakMember(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 18.5C13.9706 18.5 18 14.4706 18 9.5C18 4.52944 13.9706 0.5 9 0.5C4.02944 0.5 0 4.52944 0 9.5C0 14.4706 4.02944 18.5 9 18.5Z",
    fill: "#223D8D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 0.5C13.9626 0.5 18 4.53743 18 9.5C18 14.4626 13.9626 18.5 9 18.5V0.5Z",
    fill: "#223D8D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7708 13.975H5.2291C4.90602 13.975 4.62437 13.7551 4.54603 13.4416L3.0377 7.40827C2.97104 7.14151 3.06572 6.86033 3.28024 6.6883C3.49471 6.51617 3.78973 6.48481 4.03569 6.60775L6.46917 7.82449L8.39626 4.61269C8.52351 4.40062 8.75268 4.27087 9.00001 4.27087C9.24733 4.27087 9.4765 4.40066 9.60375 4.61269L11.5308 7.82449L13.9644 6.60775C14.2101 6.48477 14.5052 6.51617 14.7198 6.6883C14.9343 6.86033 15.029 7.14151 14.9623 7.40827L13.4539 13.4416C13.3755 13.7551 13.0939 13.975 12.7708 13.975Z",
    fill: "#FFD71B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7709 13.975C13.0939 13.975 13.3756 13.7551 13.4539 13.4416L14.9623 7.40827C15.029 7.14151 14.9343 6.86033 14.7198 6.6883C14.5052 6.51617 14.2102 6.48477 13.9644 6.60775L11.5308 7.82449L9.60375 4.61269C9.47649 4.40062 9.24728 4.27087 9 4.27087V13.975H12.7709Z",
    fill: "#D4AF37"
  })));
};
export default SvgVahakMember;